import { VITE_MESSAGE_SEARCH_FEATURE } from 'src/constants/envs';
import { useLoadedFeatureFlag } from 'src/hooks/featureFlags/useLoadedFeatureFlag.hook';

/**
 * Whether the message search exists for the current workspace (SRE-3328): the
 * inbox box's Mensajes section (Messenger.page, useInboxSearch) and the
 * per-contact "Buscar en esta conversación" (ChatSearchProvider: magnifier,
 * Ctrl/⌘+F, bar, marks).
 *
 * Both gates must hold:
 * - `VITE_MESSAGE_SEARCH_FEATURE`, the build-time global kill switch. Off, no
 *   workspace gets the search, whatever its stored flag says.
 * - `chat_message-search`, the STORED per-workspace rollout flag. Read through
 *   useLoadedFeatureFlag, so it is false until THIS workspace's flags have
 *   settled: the search never flashes for a workspace outside the cohort, and
 *   a failed flags fetch leaves it off.
 *
 * Every surface reads this hook rather than either gate, so the AND lives in
 * one place.
 */
export default function useMessageSearchEnabled(): boolean {
  const isReleasedHere = useLoadedFeatureFlag('chat_message-search');

  return VITE_MESSAGE_SEARCH_FEATURE && isReleasedHere;
}
